import React from 'react';
import { domeImages } from '../data/dome';
import { FadeIn } from './FadeIn';
import { SafeImage } from './SafeImage';
const USES = ['Yoga & movement', 'Breathwork & meditation', 'Workshops & circles', 'Live music & celebration'];

/**
 * The Dome is the heart of the retreat space, so it gets its own section
 * with a single dominant photograph and a supporting run of moments.
 */
export function DomeShowcase() {
  const [lead, ...rest] = domeImages;
  return <section id="dome" className="scroll-mt-20 bg-charcoal px-6 py-20 md:px-12 md:py-32" data-id="element-200" data-mp="3m739tj3a4ta4">
      <div className="mx-auto max-w-6xl" data-id="element-201" data-mp="3m9g0qlr0mdzb">
        <div className="mb-10 grid grid-cols-1 gap-8 md:mb-14 md:grid-cols-12 md:items-end" data-id="element-202" data-mp="42jid2vxkjhx">
          <div className="md:col-span-7" data-id="element-203" data-mp="3v7i61dhs7sse">
            <FadeIn data-id="element-204" data-mp="3v6gmekmp9xz2">
              <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-sand/70" data-id="element-205" data-mp="1fgnbk6up23lx">
                The Dome
              </p>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-206" data-mp="1ah0xxwayelcl">
              <h2 className="font-serif text-4xl leading-tight text-offwhite md:text-5xl" data-id="element-207" data-mp="1ajwtjdzbwxxv">
                A round room that holds a group.
              </h2>
            </FadeIn>
          </div>
          <div className="md:col-span-5" data-id="element-208" data-mp="1tpm6k9qfn9mp">
            <FadeIn delay={0.2} data-id="element-209" data-mp="1ymkzwq29vcju">
              <p className="mb-6 font-light leading-relaxed text-sand/90" data-id="element-210" data-mp="1ynnogrc4h2wl">
                Warm timber floors, colour-washed walls, a sound system and instruments
                already in the room. Wide open for movement by day, low-lit and intimate
                by night.
              </p>
            </FadeIn>
            <FadeIn delay={0.25} data-id="element-211" data-mp="1av77yl819ize">
              <ul className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-sand/70" data-id="element-212" data-mp="1fvuw8z4vnlpx">
                {USES.map(use => <li key={use} className="flex items-center gap-2" data-id="element-213" data-mp="1ko4qgrd0z7y0">
                    <span className="h-1 w-1 rounded-full bg-gold" data-id="element-214" data-mp="n7z487q96hzh" />
                    {use}
                  </li>)}
              </ul>
            </FadeIn>
          </div>
        </div>

        <FadeIn data-id="element-215" data-mp="k5kry3co5qj6">
          <figure className="mb-3 overflow-hidden rounded-sm md:mb-4" data-id="element-216" data-mp="k5198kf72y43">
            <SafeImage src={lead.src} fallbackSrc={domeImages[1].src} alt={lead.alt} className="h-[52vh] w-full object-cover md:h-[70vh]" data-id="element-217" data-mp="g4r397rek7p8" />
          </figure>
        </FadeIn>

        <div className="grid grid-cols-2 gap-3 md:grid-cols-12 md:gap-4" data-id="element-218" data-mp="oy44cwzmefme">
          {rest.map((image, index) => {
          const spans = ['md:col-span-7', 'md:col-span-5', 'md:col-span-5', 'md:col-span-7', 'md:col-span-6', 'md:col-span-6'];
          return <FadeIn key={image.src} delay={Math.min(index, 4) * 0.05} className={`col-span-1 ${spans[index] ?? 'md:col-span-6'}`} data-id="element-219" data-mp="65s4qi0cpsfy" data-mpi={index}>
                <figure className="h-full overflow-hidden rounded-sm" data-id="element-220" data-mp="1hm0121p6w7j6">
                  <SafeImage src={image.src} fallbackSrc={lead.src} alt={image.alt} loading="lazy" className="aspect-[4/3] w-full object-cover" data-id="element-221" data-mp="1hnuj9892tljk" />
                </figure>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}